import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class H2hRequestParams extends BaseApiRequestParams {
  gameId: Number;

  constructor(gameId: Number, matchupId: String, topBookmaker: Number, addMainOdds: Boolean) {
    super('games/h2h/');

    this.gameId = gameId;
    this.matchupId = matchupId;
    this.topBookmaker = topBookmaker;
    this.addMainOdds = addMainOdds;
  }

  get gameIdParam() {
    return this.gameId  ? `&gameId=${this.gameId}` : '';
  }

  get matchupIdParam() {
    return this.matchupId  ? `&matchupId=${this.matchupId}` : '';
  }

  get topBookmakerParam() {
    return this.topBookmaker > 0  ? `&topBookmaker=${this.topBookmaker}` : '';
  }

  get addMainOddsParam() {
    return this.addMainOdds ? `&addMainOdds=${this.addMainOdds}` : '';
  }

  toString(): string {
    return super.toString() + this.gameIdParam + this.matchupIdParam + this.topBookmakerParam + this.addMainOddsParam;
  }

  equals(model: H2hRequestParams): * {
    let equals = super.equals(model);

    equals &= this.gameIdParam === model.gameIdParam;
    equals &= this.matchupIdParam === model.matchupIdParam;
    equals &= this.topBookmakerParam === model.topBookmakerParam;
    equals &= this.addMainOddsParam === model.addMainOddsParam;

    return equals;
  }
}
